import {
  pageInfo,
  exportData,
  areaCityEditInit,
  submit,
  deleteAreaCity
} from './../api';
const areaCity = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initObj: null,
    exportObj: null,
    submitObj: null,
    deleteObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    EXPORT_DATA(state, data){
      state.exportObj = data;
    },
    AREACITY_EDIT_INIT(state, data){
      state.initObj = data;
    },
    SUBMIT(state, data){
      state.submitObj = data;
    },
    DELETE_AREACITY(state, data){
      state.deleteObj = data;
    },
  },
  actions: {
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async areaCityEditInit({commit}, obj) {
      let resp = await areaCityEditInit(obj);
      commit('AREACITY_EDIT_INIT', resp);
    },
    async submit({commit}, obj) {
      let resp = await submit(obj);
      commit('SUBMIT', resp);
    },
    async deleteAreaCity({commit}, obj) {
      let resp = await deleteAreaCity(obj);
      commit('DELETE_AREACITY', resp);
    },
  }
};
export default areaCity



// WEBPACK FOOTER //
// ./src/page/md/areaCity/store/areaCity.store.js